import script from "./method-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./method-field.vue?vue&type=script&setup=true&lang=ts"

import "./method-field.vue?vue&type=style&index=0&id=3d6608a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d6608a0"]])

export default __exports__